import React from 'react';
import routes from '@routes';
import { Content } from '@layout';
import logo from '@images/logo-white.svg';
import { Link } from 'gatsby';
import styles from './Footer.module.scss';

export default React.memo(function Footer() {
  return (
    <footer className={styles.wrapper}>
      <Content>
        <div className={styles.top}>
          <Link to="/">
            <img
              src={logo}
              alt="Tripati Lab"
            />
          </Link>
          <nav className={styles.nav}>
            {routes.map((item, index) => (
              <NavColumn
                key={index}
                {...item}
              />
            ))}
          </nav>
        </div>
        <div className={styles.copyright}>
          © {new Date().getFullYear()} Tripati Lab. All rights reserved
        </div>
      </Content>
    </footer>
  );
});

function NavColumn({ text, to: parentTo, subLinks = [] }) {
  return (
    <ul className={styles.column}>
      <li>
        <Link to={`/${parentTo}`}>{text}</Link>
      </li>
      {subLinks.map(({ text, to }, index) => (
        <li key={index}>
          <Link to={`/${parentTo}/${to}`}>{text}</Link>
        </li>
      ))}
    </ul>
  );
}
